import React from 'react';
import LotItem from '../../lot-item/js/LotItem';
import PropTypes from 'prop-types';

export default class LotSearchItem extends React.PureComponent {

    render() {
        return (
            <div
                className="listing__item grid__item grid__item--span-mobile-ls-6 grid__item--span-tablet-4 grid__item--span-desktop-3">
                <LotItem item={this.props.item}/>
            </div>
        );
    }
}

LotSearchItem.propTypes = {
    item: PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./app/components/lots-search/js/LotSearchItem.js